import { Fragment } from 'react'

export default function SdgWizardNav({
  pages,
  activePage,
  setActivePage,
  pageReached,
}: {
  pages: {
    id: string
    title: string
    children: React.ReactNode
  }[]
  activePage: number
  setActivePage: (page: number) => void
  pageReached: number
}) {
  let navItemClass = `
    flex 
    items-center 
    gap-xxs
    w-full
    p-s 
    border 
    rounded-sm
    text-[length:--p-size]
    font-bold
    mb-0
    transition-colors

    ms:p-xs
    ms:text-[length:--p-s-size]
  `

  const navItems = [
    ...pages,
    {
      id: 'results',
      title: 'Results',
      children: <div>Results</div>,
    },
  ]

  return (
    <div className="border-b py-l">
      <div className="container">
        <div className="flex flex-col gap-s">
          <span className="p--small mb-0">SDG Tool</span>

          <nav>
            <ol className="flex w-full items-center gap-xs">
              {navItems.map((page, index) => {
                const isActive = activePage === index
                const completed = index < pageReached
                const canNavigate = index <= pageReached

                return (
                  <Fragment key={page.id}>
                    <li
                      className={`${navItemClass} ${isActive ? 'border-fg-title' : ''} ${canNavigate ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                      onClick={() => (canNavigate ? setActivePage(index) : null)}>
                      {completed ? (
                        <div className="flex h-[24px] w-[24px] flex-shrink-0 items-center justify-center rounded-full bg-grey-100">
                          <svg
                            aria-hidden="true"
                            className="aspect-square w-[10px] text-primary"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 12 10">
                            <path
                              stroke="currentColor"
                              strokeWidth="2"
                              d="m1 4.99996 3.33333 3.33333L11 1.66663"
                            />
                          </svg>
                        </div>
                      ) : null}

                      {page.title}
                    </li>

                    {index < navItems.length - 1 ? (
                      <svg aria-hidden="true" className="h-[20px] w-[20px] flex-shrink-0 ms:hidden">
                        <use href={`${process.env.NEXT_PUBLIC_SPRITE_PATH}#icon-arrow-right`}></use>
                      </svg>
                    ) : null}
                  </Fragment>
                )
              })}
            </ol>
          </nav>
        </div>
      </div>
    </div>
  )
}
